import { useState } from "react";
import { supabaseConfigured } from "./lib/supabase";
import PostsFeed from "./views/PostsFeed";
import Costs from "./views/Costs";
import Lanes from "./views/Lanes";
import SourceHealth from "./views/SourceHealth";
import Adapters from "./views/Adapters";

type View = "posts" | "costs" | "lanes" | "sources" | "adapters";

const TABS: { key: View; label: string }[] = [
  { key: "posts",    label: "Posts" },
  { key: "costs",    label: "Costs" },
  { key: "lanes",    label: "Lanes" },
  { key: "sources",  label: "Sources" },
  { key: "adapters", label: "Adapters" },
];

export default function App() {
  const [view, setView] = useState<View>("posts");

  return (
    <div className="min-h-full flex flex-col">
      <header className="border-b border-ink-700 bg-ink-900/80 backdrop-blur sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-base font-semibold tracking-tight">Content Engine — Ops</h1>
            <p className="text-xs text-chrome-400 font-mono">prepper · 159.89.227.66</p>
          </div>
          <nav className="flex gap-1">
            {TABS.map((t) => (
              <button
                key={t.key}
                onClick={() => setView(t.key)}
                className={`px-3 py-1.5 text-sm rounded transition ${
                  view === t.key
                    ? "bg-ink-700 text-chrome-100"
                    : "text-chrome-300 hover:bg-ink-800"
                }`}
              >
                {t.label}
              </button>
            ))}
          </nav>
        </div>
      </header>

      <main className="flex-1 max-w-7xl mx-auto w-full px-6 py-6">
        {!supabaseConfigured && (
          <div className="card border-warn/40 bg-warn/5 mb-6">
            <p className="text-sm text-warn">
              <span className="font-semibold">Not configured.</span>{" "}
              <code className="font-mono">VITE_SUPABASE_URL</code> and{" "}
              <code className="font-mono">VITE_SUPABASE_ANON_KEY</code> are missing —
              copy <code>.env.example</code> to <code>.env</code> and fill them in.
            </p>
          </div>
        )}
        {view === "posts"    && <PostsFeed />}
        {view === "costs"    && <Costs />}
        {view === "lanes"    && <Lanes />}
        {view === "sources"  && <SourceHealth />}
        {view === "adapters" && <Adapters />}
      </main>

      <footer className="border-t border-ink-700 text-xs text-chrome-400 py-3 text-center">
        Built on Supabase · Deployed via Cloudflare Pages
      </footer>
    </div>
  );
}
